import { render } from "./HomeFeatures.vue?vue&type=template&id=1c7eb239&scoped=true&ts=true&lang=pug"
import script from "./HomeFeatures.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeFeatures.vue?vue&type=script&lang=ts&setup=true"

import "./HomeFeatures.vue?vue&type=style&index=0&id=1c7eb239&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7eb239"]])

export default __exports__